import { useState } from 'react';
import { useLang } from '@/common/Contexts/LanguageContext';
import brands_tree_ar from '../../../data/lookups/brands_tree_ar.json';
import brands_tree_en from '../../../data/lookups/brands_tree_en.json';
import { generateYearsFrom } from '@/utils/GlobalJavascriptFunction';
var useBrandsData = function useBrandsData() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    forcedLang = _ref.forcedLang;
  var lang = forcedLang !== null && forcedLang !== void 0 ? forcedLang : useLang();
  var _useState = useState(true),
    isLoading = _useState[0],
    setIsLoading = _useState[1];
  var data = lang === 'ar' ? brands_tree_ar : brands_tree_en;
  var makes = data.makes || [];
  var models = data.models || [];
  var extensions = data.extensions || [];
  var years = generateYearsFrom(2016);
  var getModelsByMakeId = function getModelsByMakeId(makeId) {
    return models.filter(function (model) {
      return model.make_id === makeId;
    });
  };
  var getExtensionsByModelId = function getExtensionsByModelId(modelId, makeId) {
    return extensions.filter(function (ext) {
      return ext.model_id === modelId && ext.make_id === makeId;
    });
  };
  var getMakeById = function getMakeById(makeId) {
    return makes.find(function (make) {
      return make.id === makeId;
    });
  };
  var getModelById = function getModelById(modelId) {
    return models.find(function (model) {
      return model.id === modelId;
    });
  };
  var getExtensionById = function getExtensionById(extensionId) {
    return extensions.find(function (ext) {
      return ext.id === extensionId;
    });
  };
  return {
    makes: makes,
    models: models,
    extensions: extensions,
    years: years,
    getModelsByMakeId: getModelsByMakeId,
    getExtensionsByModelId: getExtensionsByModelId,
    getMakeById: getMakeById,
    getModelById: getModelById,
    getExtensionById: getExtensionById,
    isLoading: isLoading
  };
};
export default useBrandsData;